import { Box, CircularProgress, Tab, Tabs, Typography } from "@mui/material"
import { FC } from "react"
import { useSearchParams } from "react-router-dom"
import useAccessRole from "../Common/useAccessRole"
import AdminBnBReportedIssues from "../AdminBnBReportedIssues"

// Everything to do with BnB stays, in one place - starting with what guests report. Super admin only for now, like the lock
// store's Orders tab; more tabs (e.g. a bookings overview) can join this the same way the Locks page grew its own.
type Role = 'super' | 'admin'
const TABS: { key: string, label: string, roles: Role[], element: JSX.Element }[] = [
    { key: 'reported-issues', label: 'Reported Issues', roles: ['super'], element: <AdminBnBReportedIssues /> }
]

const AdminBnBTabs: FC = () => {
    const role = useAccessRole()
    const [params, setParams] = useSearchParams()

    if (!role)
        return <Box sx={{ display: 'flex', justifyContent: 'center', pt: 8 }}><CircularProgress size={26} /></Box>
    if (role === 'user')
        return <Typography sx={{ p: 3, color: 'text.secondary' }}>You do not have access to this page.</Typography>

    const tabs = TABS.filter(tab => tab.roles.includes(role))
    if (!tabs.length)
        return <Typography sx={{ p: 3, color: 'text.secondary' }}>You do not have access to this page.</Typography>
    const current = tabs.find(tab => tab.key === params.get('tab')) || tabs[0]

    return (
        <Box sx={{ height: '100%' }}>
            <Typography sx={{ fontSize: 25, fontWeight: 'bold', mt: 1 }}>BnB</Typography>
            <Tabs
                value={current.key}
                onChange={(_e, key) => setParams({ tab: key }, { replace: true })}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ mb: 1, borderBottom: 1, borderColor: 'divider', maxWidth: 'calc(100% - 40px)' }}
            >
                {tabs.map(tab => <Tab key={tab.key} value={tab.key} label={tab.label} sx={{ textTransform: 'none', fontWeight: 600 }} />)}
            </Tabs>
            {/* only the open tab is mounted, so the others do not load until they are opened */}
            <Box key={current.key}>{current.element}</Box>
        </Box>
    )
}

export default AdminBnBTabs
